import GeometryType from "./GeometryType";
const GeoJsonType = Object.freeze({
  ...GeometryType,
  FEATURE: "Feature",
  FEATURE_COLLECTION: "FeatureCollection"
});
export default GeoJsonType;